import React from 'react'
import { Col, Row } from 'antd'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { InfoItem } from 'Pages/Merchants/components'
import { TaxData } from 'Store/tax-management/types'

type Props = {
  detail?: TaxData
}

const ClientInfo: React.FunctionComponent<Props> = props => {
  const { detail } = props

  const renderInfo = (title: string, value: any, span: number = 15) => {
    return <InfoItem title={title} value={value} span={span} />
  }

  return (
    <BoxWrapper>
      <BoxTitle>ข้อมูลลูกค้า</BoxTitle>
      <Row>
        <Col md={24} xs={24}>
          {renderInfo('ชื่อลูกค้า/บริษัท', detail?.name)}
          {renderInfo('เลขประจำตัวผู้เสียภาษี', detail?.taxpayer_no)}
          {renderInfo('ที่อยู่', detail?.address)}
          {renderInfo('เบอร์โทรศัพท์', detail?.mobile)}
        </Col>
      </Row>
    </BoxWrapper>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`
export default ClientInfo
